import type { FC } from 'react';

import { SidebarItem } from '@mint-lib/tw-components/patterns';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { MP_LEVELS } from '../../../consts/index.js';
import { levelIcons } from '../../../consts/sidebar.js';
import { useChosenLevel } from '../../../hooks/useChosenLevel.js';

const levelIndentClasses: Record<number, string> = {
  1: 'pl-4 data-[expandable=false]:pl-10',
  2: 'pl-6 data-[expandable=false]:pl-12',
};

type Props = {
  nestingLevel?: number;
  isExpanded: Record<string, boolean>;
  items: MediaPlan.SidebarItem[];
  handleItemClick: (item: MediaPlan.SidebarItem) => void;
  toggleSubMenu: (mediaDataId: string, level: string) => void;
};

const SidebarItems: FC<Props> = ({
  nestingLevel = 1,
  items,
  isExpanded,
  handleItemClick,
  toggleSubMenu,
}) => {
  const { id } = useChosenLevel();

  return (
    <>
      {items.map((item) => {
        const expandable = !!item.subItems.length;
        const isActivityDisabled = item.level === MP_LEVELS.ACTIVITY;
        const LevelIcon = levelIcons[item.level as keyof typeof levelIcons];

        return (
          <div key={item.mediaDataId}>
            <SidebarItem
              className={levelIndentClasses[nestingLevel]}
              variant="secondary"
              text={item.name}
              icon={LevelIcon && <LevelIcon />}
              expandable={expandable}
              onClick={() => handleItemClick(item)}
              onChevronClick={() => toggleSubMenu(item.mediaDataId, item.level)}
              open={isExpanded[item.mediaDataId]}
              selected={item.mediaDataId === id}
              data-dd-action-name="Planning sidebar: open level"
              disabled={isActivityDisabled}
            />
            {isExpanded[item.mediaDataId] && item.subItems && (
              <SidebarItems
                nestingLevel={nestingLevel + 1}
                items={item.subItems}
                isExpanded={isExpanded}
                handleItemClick={handleItemClick}
                toggleSubMenu={toggleSubMenu}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default SidebarItems;
